import React from "react";

const budgetList = [
    {
        name: 'Awareness',
        allocation: '25%',
        budget: '$250,000.00',
        spentPercent: '90%',
        spentDollar: '$225,000.00',
        remaining: '$25000.00'
    },
    {
        name: 'Awareness',
        allocation: '25%',
        budget: '$250,000.00',
        spentPercent: '90%',
        spentDollar: '$225,000.00',
        remaining: '$25000.00'
    },
    {
        name: 'Awareness',
        allocation: '25%',
        budget: '$250,000.00',
        spentPercent: '90%',
        spentDollar: '$225,000.00',
        remaining: '$25000.00'
    },

]
const BudgetTableList = () => {
    
  
    
    return (<>
        <table className="table table-hover">
            <thead>
                <tr>
                    <th></th>
                    <th>Allocation (%)</th>
                    <th>Budget ($)</th>
                    <th>Spent (%)</th>
                    <th>Spent ($)</th>
                    <th>Remaining</th>
                </tr>
            </thead>
            <tbody>
                {/* <th scope="row">1</th> */}
                {budgetList.map((budget, i) => {
                    return (<tr className="bg-blue budget-table" key={i}>
                        <td>{budget.name}</td>
                        <td>{budget.allocation}</td>
                        <td>{budget.budget}</td>
                        <td>{budget.spentPercent}</td>
                        <td>{budget.spentDollar}</td>
                        <td>{budget.remaining}</td>
                    </tr>)
                })}
            </tbody>
        </table>
    </>)
}
export default BudgetTableList;